/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { notification, message } from 'antd';
import { auth } from '../../../firebase';
import * as AuthAPI from '../../../api/auth';
import { setAppIsLoading } from '../../loading/actions';
import TEXTS from './_texts';

const lang = 'fr';

export const SET_USER = 'SET_USER';

export const setUser = value => ({
    type: SET_USER,
    payload: value,
});


export const sessionExpired = async (err, dispatch) => {
    const errMsg = TEXTS[err.code];
    if (errMsg) {
        notification.error({
            message: TEXTS.errorNotificationMessage[lang],
            description: errMsg[lang],
        });
        dispatch(setUser(null));
    } else if (err.response && err.response.data) {
        if (err.response.data.code === 'auth/argument-error') {
            await auth.signOut();
            await AuthAPI.logout();
            dispatch(setUser(null));
        }
    }
};


export const checkAuthAsync = () => async (dispatch) => {
    dispatch(setAppIsLoading(true));
    try {
        const authStatus = await AuthAPI.getStatus();
        if (authStatus.user) dispatch(setUser(authStatus.user));
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setAppIsLoading(false));
};


export const recoverPassword = async (email) => {
    try {
        await auth.sendPasswordResetEmail(email);
        notification.success({
            message: TEXTS.notifEmailVerificationSuccessMessage[lang],
            description: TEXTS.notifPasswordResetSuccessDescription[lang],
        });
    } catch (err) {
        sessionExpired(err);
    }
};

export const loginAsync = credentials => async (dispatch) => {
    dispatch(setAppIsLoading(true));
    try {
        const res = await auth.signInWithEmailAndPassword(
            credentials.email,
            credentials.password,
        );
        if (res.user) {
            const idToken = await res.user.getIdToken(true);
            const id = res.user.uid;
            const response = await AuthAPI.login({ idToken, id });
            const AuthenticatedUser = response.user;
            dispatch(setUser(AuthenticatedUser));
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }

    dispatch(setAppIsLoading(false));
};

export const disconnectAsync = () => async (dispatch) => {
    dispatch(setAppIsLoading(true));
    try {
        await auth.signOut();
        await AuthAPI.logout();
        dispatch(setUser(null));
        message.success(TEXTS.sucessDisconnect[lang]);
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setAppIsLoading(false));
};
